module.exports = __webpack_public_path__ + "img/5.ce15bfd6.jpg";